<template>
  <div class="c-talks" :class="{ wide: singleScreen }">
    <div class="c-header-wrap c-flex ac w100">
      <div v-if="!routeCid && cid" class="c-commin-filter">
        <community-chip-s :cid="cid" wCss="sm" close v-model="cid_chip" @click.stop.prevent="cid = 0" />
      </div>
      <div class="c-search s">
        <v-text-field
          class="c-search-word"
          v-model="searchKey"
          append-icon="search"
          :placeholder="$T('common.search')"
          color="clr-primary"
        ></v-text-field>
      </div>
      <div class="c-btn-add">
        <v-tooltip bottom>
          <v-btn :disabled="isGuest" slot="activator" flat icon color="clr-btn" @click="createDialog = true">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <span>{{ $T('talk.create.title') }}</span>
        </v-tooltip>
      </div>
    </div>

    <div class="c-list">
      <v-list three-line class="c-talk-list">
        <template v-for="(talk, index) in list">
          <v-divider v-if="index > 0" :key="index" inset class="c-div"></v-divider>

          <talk-list-tile :talk="talk" @click="onClick" :friends="curFriends" />
        </template>
        <tail-loader v-if="filteredList" :srcs="filteredList" :unit="10" v-model="list" />
        <div v-if="nodata" class="c-none">{{ $T('talk.notalks') }}</div>
      </v-list>
    </div>

    <edit-talk-dialog v-if="createDialog" @close="createDialog = false" />
  </div>
</template>

<script>
import editTalkDialog from './EditTalkDialog.vue';
import talkListTile from './TalkListTile.vue';
import { mapGetters, mapActions } from 'vuex';
import { CONST } from '../../constant';

export default {
  components: {
    'talk-list-tile': talkListTile,
    'edit-talk-dialog': editTalkDialog,
  },
  props: {
    talkList: { type: Array, required: true },
    singleScreen: { type: Boolean, required: true },
    friends: { type: Object, required: false },
  },
  data() {
    return {
      cid: 0,
      searchKey: null,
      createDialog: false,
      list: [],
      curFriends: this.friends || {},
    };
  },
  mounted() {
    if (this.isSp) return;
    $('.c-list').mCustomScrollbar({
      theme: 'minimal',
      axis: 'y',
      scrollbarPosition: 'outside',
      advanced: {
        updateOnContentResize: true,
        updateOnBrowserResize: true,
      },
      onUpdate: function() {
        console.log('talk list scroll updated');
      },
    });
  },
  computed: {
    routeCid() {
      return this.selectedCommunity.id;
    },
    filteredList() {
      var cid = this.getRouteCid() ? this.getRouteCid() : this.cid;
      var words = fmtSearchWord(this.searchKey);
      return cid || words
        ? this.talkList.filter(data => {
            var stw = data.stw;
            if (!stw) {
              stw = fmtSearchTgtWord(`${data.name} ${this.getCommunityName(data.cid)}}`);
              data.stw = stw;
            }
            return (!cid || data.cid == cid) && wordMatch(words, stw);
          })
        : this.talkList;
    },
    nodata() {
      return this.filteredList.length == 0;
    },
  },
  methods: {
    onClick(talk) {
      this.$store.commit('TALK_SELECT', talk.id);
      this.setTalkListener();
      this.$router.push({ name: 'talkDetail', params: { talk_id: talk.id } });
    },
    fmtTime(talk) {
      return this.diffDateFormatShort(this.$moment.unix(talk.last_tstamp));
    },
    ...mapActions({
      setTalkListener: 'setTalkListener',
    }),
  },
};
</script>

<style scoped>
.c-header-wrap {
  position: sticky;
  top: 79px;
  z-index: 5;
  height: 60px;
  background-color: #fff;
  z-index: 5;
  min-width: 220px;
  max-width: 220px;
}
.wide .c-header-wrap {
  min-width: initial;
  max-width: initial;
}
.le-tbs .c-header-wrap {
  position: fixed;
  top: 48px;
  right: 0;
  height: 48px;
}
.c-talks {
  min-width: 220px;
  max-width: 220px;
}
.le-tbs .c-talks {
  margin-top: 48px;
}
.c-talks.wide {
  min-width: 100%;
  max-width: 100%;
}
.c-talks.wide .c-header-wrap {
  padding-left: 12px;
}
.le-sp .c-talks {
  min-width: 100%;
  width: 100%;
}
.c-list {
  height: calc(100vh - 222px);
  overflow: scroll;
}
.le-tbs .c-list {
  height: calc(100vh - 156px);
}
.le-sp .c-list {
  height: initial !important;
  padding-bottom: 60px;
}
.c-talk-list {
  padding: 0;
}
.c-div {
  margin-left: 60px;
  max-width: calc(100% - 60px);
}
.c-btn-add {
  margin: 0 10px 0 0;
}
.wide .c-btn-add {
  margin: 0 20px 0 10px;
}
.le-tbs .wide .c-btn-add {
  margin: 0 10px 0 0;
}
.c-btn-add i {
  font-size: 28px;
}
.c-none {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 300px);
  min-height: 300px;
  width: 100%;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
}
.le-tbs .c-none {
  height: calc(100vh - 225px);
}
.wide .c-none {
  font-size: 20px;
}
.c-search-word {
  width: 150px;
}
.wide .c-search-word {
  width: initial !important;
  margin-right: 12px !important;
}
</style>
